export function formatCurrency(amount: number, currencyCode: string): string {
    if (!Number.isFinite(amount)) {
        return '';
    }
    if (!currencyCode) return String(amount);
    return new Intl.NumberFormat(navigator.language, {
        style: 'currency',
        currency: currencyCode
    }).format(amount);
}
